export const DATA_TABLE_PAGE_SIZES = [10, 25, 50, 100] as const;

export type DataTablePageSize = (typeof DATA_TABLE_PAGE_SIZES)[number];
